import { Component, HostListener, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { ArgumentsService } from 'src/app/_services/arguments.service';
import { ScrumService } from 'src/app/_services/scrum.service';

@Component({
  selector: 'app-modale-story-points',
  templateUrl: './modale-story-points.component.html',
  styleUrls: ['./modale-story-points.component.css']
})
export class ModaleStoryPointsComponent implements OnInit {
  isDesktopMode: boolean = false;
  isMobileMode: boolean = !this.isDesktopMode;
  storyPoints: any[] = [];
  storypointCategories: any[] = [];
  form: FormGroup;
  search_hours_effortControl = new FormControl<any>(null);
  search_hours_uncertaintyControl = new FormControl<any>(null);
  search_quotesControl = new FormControl<any>('');
  selected_uncertaintyControl = new FormControl<any>('');
  selected_complexityControl = new FormControl<any>('');
  selected_effortControl = new FormControl<any>('');
  resetClicked = true;
  showCalculateComplexity: boolean = false;
  argumentsBackend: any;
  argumentsFrontend: any;
  frontendArguments: any;
  selectedFrontendArgs: any;
  selectedBackend: any;
  microArgFe: any;
  microArgBe: any;
  selectedMicroArgFe: any;
  selectedMicroArgBe: any;
  calculateComplexity: any;
  selectedMicroArgs: any;
  microArgumentParams = {
    filter_search: 'asinc'
  };

  selectedMicroFeChips: any[] = [];
  selectedMicroBeChips: any[] = [];

  showTrashIcon: boolean = false;

  filtersTable: any = {
    search_quotes: ['', [Validators.required, Validators.minLength(3)]],
    search_hours_effort: null,
    search_hours_uncertainty: null,
    selected_uncertainty: [],
    selected_complexity: [],
    selected_effort: []
  };

  incertezza_quotes: any;
  effort_quotes: any;
  complessita_quotes: any;
  selectedIncertezza = new Array();
  selectedComplessita = new Array();
  selectedEffort = new Array();
  inputLength: number = 0;
  isHourInput: boolean = false;

  constructor(
    private scrumService: ScrumService,
    private argumentService: ArgumentsService,
    private fb: FormBuilder
  ) {}

  async ngOnInit(): Promise<void> {
    this._initSearchForm();
    this.checkScreenSize();
    this.valuechanges();

    this.fetchStoryPoints();
    this.argumentService.getArguments().subscribe(r => {
      this.argumentsBackend = r[0].backend_argument;
      this.argumentsFrontend = r[0].frontend_argument;
    });
  }

  _initSearchForm() {
    this.form = this.fb.group({
      search_quotes: this.search_quotesControl.value,
      search_hours_effort: this.search_hours_effortControl.value,
      search_hours_uncertainty: this.search_hours_uncertaintyControl.value,
      selected_uncertainty: this.selected_uncertaintyControl.value,
      selected_complexity: this.selected_complexityControl.value,
      selected_effort: this.selected_effortControl.value
    });
  }

  valuechanges() {
    this.search_quotesControl.valueChanges
      .pipe(distinctUntilChanged(), debounceTime(1000))
      .subscribe(() => {
        this.fetchStoryPoints();
      });
    this.search_hours_effortControl.valueChanges
      .pipe(distinctUntilChanged(), debounceTime(1000))
      .subscribe(() => {
        this.fetchStoryPoints();
      });
    this.search_hours_uncertaintyControl.valueChanges
      .pipe(distinctUntilChanged(), debounceTime(1000))
      .subscribe(() => {
        this.fetchStoryPoints();
      });
    this.selected_uncertaintyControl.valueChanges
      .pipe(distinctUntilChanged(), debounceTime(1000))
      .subscribe(() => {
        this.fetchStoryPoints();
      });
    this.selected_complexityControl.valueChanges
      .pipe(distinctUntilChanged(), debounceTime(1000))
      .subscribe(() => {
        this.fetchStoryPoints();
      });
    this.selected_effortControl.valueChanges
      .pipe(distinctUntilChanged(), debounceTime(1000))
      .subscribe(() => {
        this.fetchStoryPoints();
      });
  }

  updateTrashIconVisibility(): void {
    const {
      search_quotes,
      search_hours_effort,
      search_hours_uncertainty,
      selected_uncertainty,
      selected_complexity,
      selected_effort
    } = this.form.value;
    this.showTrashIcon = !!(
      search_quotes ||
      search_hours_effort ||
      search_hours_uncertainty ||
      selected_uncertainty?.length ||
      selected_complexity?.length ||
      selected_effort?.length
    );
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isDesktopMode = window.innerWidth > 768; // Ad esempio, 768px come breakpoint
    this.isMobileMode = window.innerWidth <= 768;
  }

  fetchStoryPoints(): void {
    this.filtersTable = {
      search_quotes: this.form.controls['search_quotes'].value,
      search_hours_effort: this.form.controls['search_hours_effort'].value,
      search_hours_uncertainty:
        this.form.controls['search_hours_uncertainty'].value,
      selected_uncertainty: this.form.controls['selected_uncertainty'].value,
      selected_complexity: this.form.controls['selected_complexity'].value,
      selected_effort: this.form.controls['selected_effort'].value
    };

    this.scrumService.indexStoryPoints(this.filtersTable).subscribe(
      response => {
        this.incertezza_quotes = response?.StoryPoint_categories ?? [];
        this.complessita_quotes = response?.StoryPoint_categories ?? [];
        this.effort_quotes = response?.StoryPoint_categories ?? [];
        this.storyPoints = response?.storypoints ?? [];
      },
      error => {
        console.error('Error fetching story points:', error);
      }
    );
  }

  addToArr(item: string) {
    let arr = this.form.controls[item].value;

    switch (item) {
      case 'selected_uncertainty':
        this.selectedIncertezza = this.incertezza_quotes.filter(
          (obj: { id: number }) => arr.includes(obj.id)
        );
        break;
      case 'selected_complexity':
        this.selectedComplessita = this.complessita_quotes.filter(
          (obj: { id: number }) => arr.includes(obj.id)
        );
        break;
      case 'selected_effort':
        this.selectedEffort = this.effort_quotes.filter((obj: { id: number }) =>
          arr.includes(obj.id)
        );
        break;
      default:
        break;
    }

    // Chiamare fetchStoryPoints() solo se ci sono selezioni multiple attive
    if (arr?.length > 0) {
      this.fetchStoryPoints();
    }
  }

  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.inputLength = input.value.length;

    if (this.inputLength >= 3) {
      // Resetta i campi di input e le selezioni multiple
      this.form.controls['search_hours_uncertainty'].setValue(null);
      this.form.controls['search_hours_effort'].setValue(null);
      this.form.controls['selected_uncertainty'].setValue([]);
      this.form.controls['selected_complexity'].setValue([]);
      this.form.controls['selected_effort'].setValue([]);
      this.fetchStoryPoints();
    }

    // Se l'input è vuoto, chiama fetchStoryPoints
    if (this.inputLength === 0) {
      this.fetchStoryPoints();
      // Marca l'input come non toccato per nascondere il messaggio di avviso
      this.form.get('search_quotes')?.markAsUntouched();
    } else {
      // Marca l'input come toccato per mostrare il messaggio di avviso
      this.form.get('search_quotes')?.markAsTouched();
    }

    this.resetClicked = true;
  }

  // Funzione chiamata quando l'utente inserisce un numero nell'input
  onHoursInput(type: string, event: any) {
    const inputValue = event.target.value;

    if (type == 'uncertainty') {
      this.updateSelectedUncertaintyOptions(inputValue); // Aggiorna le selezioni di incertezza basate sul valore inserito
      this.resetClicked = true;
    } else if (type == 'effort') {
      this.updateSelectedEffortOptions(inputValue); // Aggiorna le selezioni di effort basate sul valore inserito
      this.resetClicked = true;
    }
  }

  onSelectionChange() {
    this.form.controls['search_hours_uncertainty'].setValue(null);
    this.form.controls['search_quotes'].setValue('');
    // Aggiorna i dati dei punti storia in base alle nuove selezioni
    this.fetchStoryPoints();
    this.resetClicked = true;
  }

  onSelectionChangeEffort() {
    this.form.controls['search_hours_effort'].setValue(null);
    this.form.controls['search_quotes'].setValue('');
    // Aggiorna i dati dei punti storia in base alle nuove selezioni
    this.fetchStoryPoints();
    this.resetClicked = true;
  }

  updateSelectedEffortOptions(hours: number) {
    if (hours <= 8) {
      this.form.get('selected_effort')?.setValue([1]);
      this.fetchStoryPoints();
    } else if (hours > 8 && hours <= 24) {
      this.form.get('selected_effort')?.setValue([2]);
      this.fetchStoryPoints();
    } else if (hours > 24) {
      this.form.get('selected_effort')?.setValue([3]);
      this.fetchStoryPoints();
    }
  }

  updateSelectedUncertaintyOptions(hours: number) {
    if (hours <= 4) {
      this.form.get('selected_uncertainty')?.setValue([1]);
      this.fetchStoryPoints();
    } else if (hours > 4 && hours <= 16) {
      this.form.get('selected_uncertainty')?.setValue([2]);
      this.fetchStoryPoints();
    } else if (hours > 16) {
      this.form.get('selected_uncertainty')?.setValue([3]);
      this.fetchStoryPoints();
    } else {
      this.form.get('selected_uncertainty')?.setValue([]);
    }
  }

  resetAllSelections(): void {
    this.showCalculateComplexity = false;
    this.form.reset();
    this.fetchStoryPoints();
    this.resetClicked = false;
    this.updateTrashIconVisibility();
  }

  hasData(): boolean {
    return (
      this.selectedIncertezza.length > 0 ||
      this.selectedComplessita.length > 0 ||
      this.selectedEffort.length > 0 ||
      this.filtersTable.search_hours_effort !== null ||
      this.filtersTable.search_hours_uncertainty !== null ||
      this.filtersTable.search_quotes?.length > 0
    );
  }

  //impedisce l'inserimento di altri caratteri all'infuori di S M L
  validateInput(event: KeyboardEvent): void {
    const allowedCharacters = ['s', 'm', 'l', 'S', 'M', 'L'];

    if (!allowedCharacters.includes(event.key)) {
      event.preventDefault();
    }
  }

  toggleComplexity(): void {
    this.showCalculateComplexity = !this.showCalculateComplexity;
    this.form.patchValue({
      selected_complexity: null
    });
    this.fetchStoryPoints();
    if (this.showCalculateComplexity) {
      this.selectedMicroArgs = null;
      this.selectedMicroArgFe = null;
      this.selectedMicroArgBe = null;
      this.microArgFe = null;
      this.microArgBe = null;
      this.selectedMicroFeChips = [];
      this.selectedMicroBeChips = [];
    }
  }

  onSelectionChangeCaomplexity(event: any, type?: string): void {
    let data: any;
    let skillLevelsFe: any;
    let skillLevelsBe: any;

    switch (type) {
      case 'fe':
        this.selectedFrontendArgs = event.value;
        this.argumentService
          .getMicroArgument(this.selectedFrontendArgs)
          .subscribe(r => {
            this.microArgFe = r.result;
          });
        break;

      case 'be':
        this.selectedBackend = event.value;
        this.argumentService
          .getMicroArgument(this.selectedBackend)
          .subscribe(r => {
            this.microArgBe = r.result;
          });
        break;

      case 'microFe':
        this.selectedMicroArgFe = event;

        // Aggiorno le chips
        this.selectedMicroFeChips = [...this.selectedMicroArgFe];

        skillLevelsFe = this.selectedMicroArgFe.map(
          (arg: any) => arg.skill_level
        );
        skillLevelsBe = (this.selectedMicroArgBe || []).map(
          (arg: any) => arg.skill_level
        );

        this.selectedMicroArgs = [...skillLevelsFe, ...skillLevelsBe];
        data = { microArguments: this.selectedMicroArgs };

        this.scrumService.calculateComplexity(data).subscribe(r => {
          this.calculateComplexity = [r.complexity];
          this.form.patchValue({
            selected_complexity: this.calculateComplexity
          });
          this.fetchStoryPoints();
        });
        break;

      case 'microBe':
        this.selectedMicroArgBe = event;

        // Aggiorno le chips
        this.selectedMicroBeChips = [...this.selectedMicroArgBe];

        skillLevelsBe = this.selectedMicroArgBe.map(
          (arg: any) => arg.skill_level
        );
        skillLevelsFe = (this.selectedMicroArgFe || []).map(
          (arg: any) => arg.skill_level
        );

        this.selectedMicroArgs = [...skillLevelsFe, ...skillLevelsBe];
        data = { microArguments: this.selectedMicroArgs };

        this.scrumService.calculateComplexity(data).subscribe(r => {
          this.calculateComplexity = [r.complexity];
          this.form.patchValue({
            selected_complexity: this.calculateComplexity
          });
          this.fetchStoryPoints();
        });
        break;
      default:
        break;
    }
  }

  // Metodo per rimuovere un chip
  removeChip(chip: any, type: string): void {
    if (type === 'microFe') {
      // Rimuovi il chip dalla lista delle chips
      this.selectedMicroFeChips = this.selectedMicroFeChips.filter(
        (c: any) => c !== chip
      );

      // Rimuovi il relativo elemento dalla lista degli argomenti selezionati
      this.selectedMicroArgFe = (this.selectedMicroArgFe || []).filter(
        (arg: any) => arg.alias !== chip.alias
      );

      // Aggiorna il valore della multiselect
      this.updateMultiSelect('microFe', this.selectedMicroArgFe);
    } else if (type === 'microBe') {
      // Rimuovi il chip dalla lista delle chips
      this.selectedMicroBeChips = this.selectedMicroBeChips.filter(
        (c: any) => c !== chip
      );

      // Rimuovi il relativo elemento dalla lista degli argomenti selezionati
      this.selectedMicroArgBe = (this.selectedMicroArgBe || []).filter(
        (arg: any) => arg.alias !== chip.alias
      );

      // Aggiorna il valore della multiselect
      this.updateMultiSelect('microBe', this.selectedMicroArgBe);
    }

    // Aggiorna la lista degli argomenti per il calcolo della complessità
    const skillLevelsFe = (this.selectedMicroArgFe || []).map(
      (arg: any) => arg.skill_level
    );
    const skillLevelsBe = (this.selectedMicroArgBe || []).map(
      (arg: any) => arg.skill_level
    );
    const updatedMicroArgs = [...skillLevelsFe, ...skillLevelsBe];

    const data = { microArguments: updatedMicroArgs };
    this.scrumService.calculateComplexity(data).subscribe(r => {
      this.calculateComplexity = [r.complexity];
      this.form.patchValue({
        selected_complexity:
          this.calculateComplexity[0] == '' ? [] : this.calculateComplexity
      });
      this.fetchStoryPoints();
    });
  }

  updateMultiSelect(type: string, selectedArgs: any[]): void {
    if (type === 'microFe') {
      this.selectedMicroArgFe = [...selectedArgs];
    } else if (type === 'microBe') {
      this.selectedMicroArgBe = [...selectedArgs];
    }
  }
}
